import Store from 'store/store';
import * as actions from 'store/actions';

const { handleApiResponse } = require('../utils/handleApi');
const isServer = typeof window === 'undefined';

const baseUrl = 'https://homeent.s-prod.pow.io/findanyfilm/home-ent';

export const getHomeEntData = async (fafFilmId, returnBoltSchema = false) => {
	validate(fafFilmId);
	return fetch(`${baseUrl}?fafFilmId=${fafFilmId}&returnBoltSchema=${returnBoltSchema}`)
		.then(handleApiResponse)
		.catch(error => {
			Store.emit(actions.API_ERROR, 'FindAnyFilm', error);
			return 'error';
		});
};

const baseMerchantLogoRoot = 'https://www.findanyfilm.com/images/merchant';

export const getMerchantLogo = (merchant, imageRoot) => {
	if (!merchants[merchant]) {
		return `${imageRoot}/smartHomeEnt/providerLogos/placeholder.png`;
	}
	return `${baseMerchantLogoRoot}/${merchants[merchant]}.png`;
};

const validate = (fafFilmId) => {
	if (isServer) {
		throw new Error('Trying to call service-homeent server-side');
	}
	if (!fafFilmId) {
		throw new Error('No film id given');
	}
};

const merchants = {
	amazon: 'amazon',
	argos: 'argos',
	base: 'base',
	googleplay: 'googleplay',
	hive: 'hive',
	hmv: 'hmv',
	itunes: 'itunes',
	appletvapp: 'itunes',
	moviemail: 'moviemail',
	playstation: 'playstation',
	primevideo: 'primevideo',
	primevideosub: 'primevideosub',
	rakuten: 'rakuten',
	simply: 'simply',
	skystore: 'skystore',
	talktalk: 'talktalk',
	tesco: 'tesco',
	thehut: 'thehut',
	virginmedia: 'virginmedia',
	virginstore: 'virginstore',
	zavvi: 'zavvi',
	zoom: 'zoom',
	chili: 'chili'
};
